unit uGrandPrixTile;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.Buttons, WEBLib.JSON, WEBLib.JsonData, uHelper,
  WEBLib.Storage;


type
  TBetResult = record
    username: string;
    p1: string;
    p2: string;
    p3: string;
    p4: string;
    p5: string;
    points1: integer;
    points2: integer;
    points3: integer;
    points4: integer;
    points5: integer;
  end;

type
  TfrmGrandPrixTile = class(TForm)
    pnTileContent: TPanel;
    lbGpDate: TLabel;
    pnLeft: TPanel;
    lbErgebnis: TLabel;
    pnRight: TPanel;
    lbTippUser: TLabel;
    pnErgebnis1: TPanel;
    pnErgebnis2: TPanel;
    pnErgebnis3: TPanel;
    pnErgebnis4: TPanel;
    pnErgebnis5: TPanel;
    sbErgebnis1: TSpeedButton;
    sbErgebnis2: TSpeedButton;
    sbErgebnis3: TSpeedButton;
    sbErgebnis4: TSpeedButton;
    sbErgebnis5: TSpeedButton;
    pnTipp1: TPanel;
    sbTipp1: TSpeedButton;
    pnTipp2: TPanel;
    sbTipp2: TSpeedButton;
    pnTipp3: TPanel;
    sbTipp3: TSpeedButton;
    pnTipp4: TPanel;
    sbTipp4: TSpeedButton;
    pnTipp5: TPanel;
    sbTipp5: TSpeedButton;
    btLeft: TSpeedButton;
    btRight: TSpeedButton;
    lbGpName: TLabel;
    lbPoints1: TLabel;
    lbPoints2: TLabel;
    lbPoints3: TLabel;
    lbPoints4: TLabel;
    lbPoints5: TLabel;
    procedure WebFormResize(Sender: TObject);
    procedure btRightClick(Sender: TObject);
    procedure btLeftClick(Sender: TObject);
  private
    { Private-Deklarationen }
    BetResultsPointer: integer;
    BetResults: array of TBetResult;
    procedure ClearResult;
    procedure ClearBetFields;
    procedure BetToFields;

  public
    { Public-Deklarationen }
    procedure LoadData(joData: TJSONObject);
  protected procedure LoadDFMValues; override; end;

var
  frmGrandPrixTile: TfrmGrandPrixTile;

implementation

{$R *.dfm}

procedure TfrmGrandPrixTile.BetToFields;
var
  points: string;

  procedure FormatPointsLabel(lb: TLabel; points: integer);
  begin
    if (Points = 0) then
    begin
      lb.Font.Color := clBlack;
      lb.Caption := '-';
    end else if (Points = 1) then
    begin
      lb.Font.Color := clBlack;
      lb.Caption := '+' + points.ToString;
    end else if (Points = 2) then
    begin
      lb.Font.Color := clHighlight;
      lb.Caption := '+' + points.ToString;
    end else if (Points > 2) then
    begin
      lb.Font.Color := $0000DF00;
      lb.Caption := '+' + points.ToString;
    end;
  end;

begin

  if (BetResultsPointer <= -1) then
  begin
    ClearBetFields;
    exit;
  end;

  lbTippUser.Caption := BetResults[BetResultsPointer].username;

  {console.timeLog('BetResultsPointer ' + lbGpName.Caption + ' : ' + BetResultsPointer.ToString + '/' + BetResults[BetResultsPointer].p1 + '/' +
    BetResults[BetResultsPointer].p2 + '/' + BetResults[BetResultsPointer].p3 + '/' + BetResults[BetResultsPointer].p4 + '/' +
    BetResults[BetResultsPointer].p5
  ); }

  pnTipp1.Caption := BetResults[BetResultsPointer].p1;
  pnTipp2.Caption := BetResults[BetResultsPointer].p2;
  pnTipp3.Caption := BetResults[BetResultsPointer].p3;
  pnTipp4.Caption := BetResults[BetResultsPointer].p4;
  pnTipp5.Caption := BetResults[BetResultsPointer].p5;

  FormatPointsLabel(lbPoints1, BetResults[BetResultsPointer].points1);
  FormatPointsLabel(lbPoints2, BetResults[BetResultsPointer].points2);
  FormatPointsLabel(lbPoints3, BetResults[BetResultsPointer].points3);
  FormatPointsLabel(lbPoints4, BetResults[BetResultsPointer].points4);
  FormatPointsLabel(lbPoints5, BetResults[BetResultsPointer].points5);
end;

procedure TfrmGrandPrixTile.btLeftClick(Sender: TObject);
begin
if not (High(BetResults) > 0) then
    exit;

  if (BetResultsPointer - 1 < 0) then
    BetResultsPointer := High(BetResults)
  else
    BetResultsPointer := BetResultsPointer - 1;

  BetToFields;
end;

procedure TfrmGrandPrixTile.btRightClick(Sender: TObject);
begin
  if not (High(BetResults) > 0) then
    exit;

  if (BetResultsPointer + 1 > High(BetResults)) then
    BetResultsPointer := 0
  else
    BetResultsPointer := BetResultsPointer + 1;

  BetToFields;
end;

procedure TfrmGrandPrixTile.ClearBetFields;
begin
  lbTippUser.Caption := '';

  pnTipp1.Caption := '';
  pnTipp2.Caption := '';
  pnTipp3.Caption := '';
  pnTipp4.Caption := '';
  pnTipp5.Caption := '';

  lbPoints1.Caption := '';
  lbPoints2.Caption := '';
  lbPoints3.Caption := '';
  lbPoints4.Caption := '';
  lbPoints5.Caption := '';
end;

procedure TfrmGrandPrixTile.ClearResult;
begin
  pnErgebnis1.Caption := '';
  pnErgebnis2.Caption := '';
  pnErgebnis3.Caption := '';
  pnErgebnis4.Caption := '';
  pnErgebnis5.Caption := '';
end;

procedure TfrmGrandPrixTile.LoadData(joData: TJSONObject);
var
  sprint, i, n: integer;
  jaRaceResult, jaBetResults, jaBets: TJSONArray;
  jo, joBet: TJSONObject;
  br: TBetResult;
  ls: TLocalStorage;
  username: string;
begin
(*{"race_name":"Spanish Grand Prix",
 "race_date":"23.04.2025 08:00:00",
 "sprint":1,
 "result": [
           {"position":1,
	    "givenName":"Max",
	    "familyName":"Verstappen",
      "qualipos": 2
	   },
	   {"position":2,
	    "givenName":"Lando",
	    "familyName":"Norris"
      "qualipos": 3
	   } ...
	   ]
 "betresults": [{"username":"Patrick",
       	         "isrequester":"1",
	         "bets":[
	                {"position":"1",
	                 "givenName":"Max",
	                 "familyName":"Verstappen"
		         "points":3
	                },
	                {"position":"2",
	                 "givenName":"Lando",
	                 "familyName":"Norris"
	      	         "points":1
	                } ...
		        ],
	         "sum_points":8
                }, ... *)

  lbGpName.Caption := joData.GetJSONValue('race_name');
  lbGpDate.Caption := THelper.FormatDateTimeString(joData.GetJSONValue('race_date'));
  sprint := StrToInt(joData.GetJSONValue('sprint'));
  if (sprint = 1) then
    lbGpName.Caption := lbGpName.Caption + ' (Sprint)';

  ClearResult;

  //Rennergebnis links eintragen
  jaRaceResult := TJSONArray(joData.Values['result']);
  for i := 0 to jaRaceResult.Count - 1 do
  begin
    jo := TJSONObject(jaRaceResult[i]);
    if (jo.GetJSONValue('position') = '1') then
      pnErgebnis1.Caption := jo.GetJSONValue('givenname') + ' ' + jo.GetJSONValue('familyname') + ' [' + jo.GetJSONValue('qualipos') + ']'
    else if (jo.GetJSONValue('position') = '2') then
      pnErgebnis2.Caption := jo.GetJSONValue('givenname') + ' ' + jo.GetJSONValue('familyname') + ' [' + jo.GetJSONValue('qualipos') + ']'
    else if (jo.GetJSONValue('position') = '3') then
      pnErgebnis3.Caption := jo.GetJSONValue('givenname') + ' ' + jo.GetJSONValue('familyname') + ' [' + jo.GetJSONValue('qualipos') + ']'
    else if (jo.GetJSONValue('position') = '4') then
      pnErgebnis4.Caption := jo.GetJSONValue('givenname') + ' ' + jo.GetJSONValue('familyname') + ' [' + jo.GetJSONValue('qualipos') + ']'
    else if (jo.GetJSONValue('position') = '5') then
      pnErgebnis5.Caption := jo.GetJSONValue('givenname') + ' ' + jo.GetJSONValue('familyname') + ' [' + jo.GetJSONValue('qualipos') + ']';


  end;

  //Tipps in das interne Array holen
  SetLength(BetResults, 0);
  jaBetResults := TJSONArray(joData.Values['betresults']);
  for i := 0 to jaBetResults.Count - 1 do
  begin
    jo := TJSONObject(jaBetResults[i]);
    br.username := jo.GetJSONValue('username');

    jaBets := TJSONArray(jo.Values['bets']);

    for n := 0 to jaBets.Count - 1 do
    begin
      joBet := TJSONObject(jaBets[n]);
      if (joBet.GetJSONValue('position') = '1') then
      begin
        br.p1 := joBet.GetJSONValue('givenname') + ' ' + joBet.GetJSONValue('familyname');
        br.points1 := StrToInt(joBet.GetJSONValue('points'));
      end else if (joBet.GetJSONValue('position') = '2') then
      begin
        br.p2 := joBet.GetJSONValue('givenname') + ' ' + joBet.GetJSONValue('familyname');
        br.points2 := StrToInt(joBet.GetJSONValue('points'));
      end else if (joBet.GetJSONValue('position') = '3') then
      begin
        br.p3 := joBet.GetJSONValue('givenname') + ' ' + joBet.GetJSONValue('familyname');
        br.points3 := StrToInt(joBet.GetJSONValue('points'));
      end else if (joBet.GetJSONValue('position') = '4') then
      begin
        br.p4 := joBet.GetJSONValue('givenname') + ' ' + joBet.GetJSONValue('familyname');
        br.points4 := StrToInt(joBet.GetJSONValue('points'));
      end else if (joBet.GetJSONValue('position') = '5') then
      begin
        br.p5 := joBet.GetJSONValue('givenname') + ' ' + joBet.GetJSONValue('familyname');
        br.points5 := StrToInt(joBet.GetJSONValue('points'));
      end;
    end;
    SetLength(BetResults, Length(BetResults) + 1);
    BetResults[High(BetResults)] := br;
  end;



  //Eigenen Tipp suchen
  ls := TLocalStorage.Create;
  try
    username := ls.GetValue('username');
  finally
    ls.free;
  end;

  BetResultsPointer := -1;
  if (Length(BetResults) > 0) then
  begin
    BetResultsPointer := 0; //Vorbelegen
    for i := 0 to High(BetResults) do
    begin
      if (BetResults[i].username = username) then
        BetResultsPointer := i;
    end;
  end;

  BetToFields;
end;

procedure TfrmGrandPrixTile.WebFormResize(Sender: TObject);
begin
  pnLeft.Width := Width div 2;
  pnRight.left := pnLeft.Width;
  pnRight.Width := Width - pnRight.left;
end;

procedure TfrmGrandPrixTile.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnTileContent := TPanel.Create(Self);
  lbGpDate := TLabel.Create(Self);
  lbGpName := TLabel.Create(Self);
  pnLeft := TPanel.Create(Self);
  lbErgebnis := TLabel.Create(Self);
  pnErgebnis1 := TPanel.Create(Self);
  sbErgebnis1 := TSpeedButton.Create(Self);
  pnErgebnis2 := TPanel.Create(Self);
  sbErgebnis2 := TSpeedButton.Create(Self);
  pnErgebnis3 := TPanel.Create(Self);
  sbErgebnis3 := TSpeedButton.Create(Self);
  pnErgebnis4 := TPanel.Create(Self);
  sbErgebnis4 := TSpeedButton.Create(Self);
  pnErgebnis5 := TPanel.Create(Self);
  sbErgebnis5 := TSpeedButton.Create(Self);
  pnRight := TPanel.Create(Self);
  lbTippUser := TLabel.Create(Self);
  pnTipp1 := TPanel.Create(Self);
  lbPoints1 := TLabel.Create(Self);
  sbTipp1 := TSpeedButton.Create(Self);
  pnTipp2 := TPanel.Create(Self);
  lbPoints2 := TLabel.Create(Self);
  sbTipp2 := TSpeedButton.Create(Self);
  pnTipp3 := TPanel.Create(Self);
  lbPoints3 := TLabel.Create(Self);
  sbTipp3 := TSpeedButton.Create(Self);
  pnTipp4 := TPanel.Create(Self);
  lbPoints4 := TLabel.Create(Self);
  sbTipp4 := TSpeedButton.Create(Self);
  pnTipp5 := TPanel.Create(Self);
  lbPoints5 := TLabel.Create(Self);
  sbTipp5 := TSpeedButton.Create(Self);
  btLeft := TSpeedButton.Create(Self);
  btRight := TSpeedButton.Create(Self);

  pnTileContent.BeforeLoadDFMValues;
  lbGpDate.BeforeLoadDFMValues;
  lbGpName.BeforeLoadDFMValues;
  pnLeft.BeforeLoadDFMValues;
  lbErgebnis.BeforeLoadDFMValues;
  pnErgebnis1.BeforeLoadDFMValues;
  sbErgebnis1.BeforeLoadDFMValues;
  pnErgebnis2.BeforeLoadDFMValues;
  sbErgebnis2.BeforeLoadDFMValues;
  pnErgebnis3.BeforeLoadDFMValues;
  sbErgebnis3.BeforeLoadDFMValues;
  pnErgebnis4.BeforeLoadDFMValues;
  sbErgebnis4.BeforeLoadDFMValues;
  pnErgebnis5.BeforeLoadDFMValues;
  sbErgebnis5.BeforeLoadDFMValues;
  pnRight.BeforeLoadDFMValues;
  lbTippUser.BeforeLoadDFMValues;
  pnTipp1.BeforeLoadDFMValues;
  lbPoints1.BeforeLoadDFMValues;
  sbTipp1.BeforeLoadDFMValues;
  pnTipp2.BeforeLoadDFMValues;
  lbPoints2.BeforeLoadDFMValues;
  sbTipp2.BeforeLoadDFMValues;
  pnTipp3.BeforeLoadDFMValues;
  lbPoints3.BeforeLoadDFMValues;
  sbTipp3.BeforeLoadDFMValues;
  pnTipp4.BeforeLoadDFMValues;
  lbPoints4.BeforeLoadDFMValues;
  sbTipp4.BeforeLoadDFMValues;
  pnTipp5.BeforeLoadDFMValues;
  lbPoints5.BeforeLoadDFMValues;
  sbTipp5.BeforeLoadDFMValues;
  btLeft.BeforeLoadDFMValues;
  btRight.BeforeLoadDFMValues;
  try
    Name := 'frmGrandPrixTile';
    Width := 400;
    Height := 293;
    Color := 16316922;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnTileContent.SetParentComponent(Self);
    pnTileContent.Name := 'pnTileContent';
    pnTileContent.Left := 0;
    pnTileContent.Top := 0;
    pnTileContent.Width := 400;
    pnTileContent.Height := 293;
    pnTileContent.Margins.Left := 10;
    pnTileContent.Margins.Top := 10;
    pnTileContent.Margins.Right := 10;
    pnTileContent.Margins.Bottom := 10;
    pnTileContent.Anchors := [akLeft,akTop,akRight];
    pnTileContent.BorderStyle := bsNone;
    pnTileContent.Caption := 'pnTileContent';
    pnTileContent.ChildOrder := 3;
    pnTileContent.Color := 15890688;
    pnTileContent.Font.Charset := DEFAULT_CHARSET;
    pnTileContent.Font.Color := clWindowText;
    pnTileContent.Font.Height := -12;
    pnTileContent.Font.Name := 'Tahoma, Arial, sans-serif';
    pnTileContent.Font.Style := [];
    pnTileContent.ParentFont := False;
    pnTileContent.TabOrder := 0;
    lbGpDate.SetParentComponent(pnTileContent);
    lbGpDate.Name := 'lbGpDate';
    lbGpDate.Left := 0;
    lbGpDate.Top := 24;
    lbGpDate.Width := 400;
    lbGpDate.Height := 19;
    lbGpDate.Align := alTop;
    lbGpDate.Alignment := taCenter;
    lbGpDate.Caption := '23.08.2025';
    lbGpDate.Color := 15956480;
    lbGpDate.Font.Charset := DEFAULT_CHARSET;
    lbGpDate.Font.Color := clWhite;
    lbGpDate.Font.Height := -17;
    lbGpDate.Font.Name := 'Tahoma, Arial, sans-serif';
    lbGpDate.Font.Style := [fsBold];
    lbGpDate.HeightPercent := 100.000000000000000000;
    lbGpDate.ParentFont := False;
    lbGpDate.Transparent := False;
    lbGpDate.WidthPercent := 100.000000000000000000;
    lbGpName.SetParentComponent(pnTileContent);
    lbGpName.Name := 'lbGpName';
    lbGpName.Left := 0;
    lbGpName.Top := 0;
    lbGpName.Width := 400;
    lbGpName.Height := 24;
    lbGpName.Align := alTop;
    lbGpName.Alignment := taCenter;
    lbGpName.Caption := 'Japanese Grand Prixx';
    lbGpName.Color := 15956480;
    lbGpName.Font.Charset := DEFAULT_CHARSET;
    lbGpName.Font.Color := clWhite;
    lbGpName.Font.Height := -20;
    lbGpName.Font.Name := 'Tahoma, Arial, sans-serif';
    lbGpName.Font.Style := [fsBold];
    lbGpName.HeightPercent := 100.000000000000000000;
    lbGpName.ParentFont := False;
    lbGpName.Transparent := False;
    lbGpName.WidthPercent := 100.000000000000000000;
    pnLeft.SetParentComponent(pnTileContent);
    pnLeft.Name := 'pnLeft';
    pnLeft.Left := 0;
    pnLeft.Top := 56;
    pnLeft.Width := 200;
    pnLeft.Height := 177;
    pnLeft.ChildOrder := 1;
    pnLeft.Color := 16316922;
    pnLeft.TabOrder := 0;
    lbErgebnis.SetParentComponent(pnLeft);
    lbErgebnis.Name := 'lbErgebnis';
    lbErgebnis.Left := 0;
    lbErgebnis.Top := 0;
    lbErgebnis.Width := 200;
    lbErgebnis.Height := 15;
    lbErgebnis.Align := alTop;
    lbErgebnis.Alignment := taCenter;
    lbErgebnis.Caption := 'Ergebnis';
    lbErgebnis.Font.Charset := DEFAULT_CHARSET;
    lbErgebnis.Font.Color := clWindowText;
    lbErgebnis.Font.Height := -12;
    lbErgebnis.Font.Name := 'Tahoma, Arial, sans-serif';
    lbErgebnis.Font.Style := [fsBold];
    lbErgebnis.HeightPercent := 100.000000000000000000;
    lbErgebnis.ParentFont := False;
    lbErgebnis.WidthPercent := 100.000000000000000000;
    pnErgebnis1.SetParentComponent(pnLeft);
    pnErgebnis1.Name := 'pnErgebnis1';
    pnErgebnis1.Left := 3;
    pnErgebnis1.Top := 21;
    pnErgebnis1.Width := 196;
    pnErgebnis1.Height := 32;
    pnErgebnis1.Alignment := taLeftJustify;
    pnErgebnis1.Anchors := [akLeft,akTop,akRight];
    pnErgebnis1.BorderStyle := bsNone;
    pnErgebnis1.Caption := 'Max Verstappen';
    pnErgebnis1.ChildOrder := 1;
    pnErgebnis1.Color := 15132390;
    pnErgebnis1.Font.Charset := DEFAULT_CHARSET;
    pnErgebnis1.Font.Color := clWindowText;
    pnErgebnis1.Font.Height := -12;
    pnErgebnis1.Font.Name := 'Tahoma, Arial, sans-serif';
    pnErgebnis1.Font.Style := [];
    pnErgebnis1.Padding.Left := 35;
    pnErgebnis1.ParentFont := False;
    pnErgebnis1.TabOrder := 0;
    sbErgebnis1.SetParentComponent(pnErgebnis1);
    sbErgebnis1.Name := 'sbErgebnis1';
    sbErgebnis1.Left := 1;
    sbErgebnis1.Top := 1;
    sbErgebnis1.Width := 30;
    sbErgebnis1.Height := 30;
    sbErgebnis1.Color := clNone;
    sbErgebnis1.ElementClassName := 'btn';
    sbErgebnis1.ElementFont := efCSS;
    sbErgebnis1.HeightPercent := 100.000000000000000000;
    sbErgebnis1.MaterialGlyph := 'looks_one';
    sbErgebnis1.MaterialGlyphColor := 11752960;
    sbErgebnis1.MaterialGlyphSize := 24;
    sbErgebnis1.TabOrder := 0;
    sbErgebnis1.WidthPercent := 100.000000000000000000;
    pnErgebnis2.SetParentComponent(pnLeft);
    pnErgebnis2.Name := 'pnErgebnis2';
    pnErgebnis2.Left := 3;
    pnErgebnis2.Top := 52;
    pnErgebnis2.Width := 196;
    pnErgebnis2.Height := 32;
    pnErgebnis2.Alignment := taLeftJustify;
    pnErgebnis2.Anchors := [akLeft,akTop,akRight];
    pnErgebnis2.BorderStyle := bsNone;
    pnErgebnis2.Caption := 'Mick Schumacher';
    pnErgebnis2.ChildOrder := 1;
    pnErgebnis2.Color := 16382457;
    pnErgebnis2.Font.Charset := DEFAULT_CHARSET;
    pnErgebnis2.Font.Color := clWindowText;
    pnErgebnis2.Font.Height := -12;
    pnErgebnis2.Font.Name := 'Tahoma, Arial, sans-serif';
    pnErgebnis2.Font.Style := [];
    pnErgebnis2.Padding.Left := 35;
    pnErgebnis2.ParentFont := False;
    pnErgebnis2.TabOrder := 1;
    sbErgebnis2.SetParentComponent(pnErgebnis2);
    sbErgebnis2.Name := 'sbErgebnis2';
    sbErgebnis2.Left := 1;
    sbErgebnis2.Top := 1;
    sbErgebnis2.Width := 30;
    sbErgebnis2.Height := 30;
    sbErgebnis2.Color := clNone;
    sbErgebnis2.ElementClassName := 'btn';
    sbErgebnis2.ElementFont := efCSS;
    sbErgebnis2.HeightPercent := 100.000000000000000000;
    sbErgebnis2.MaterialGlyph := 'looks_two';
    sbErgebnis2.MaterialGlyphColor := 11752960;
    sbErgebnis2.MaterialGlyphSize := 24;
    sbErgebnis2.TabOrder := 0;
    sbErgebnis2.WidthPercent := 100.000000000000000000;
    pnErgebnis3.SetParentComponent(pnLeft);
    pnErgebnis3.Name := 'pnErgebnis3';
    pnErgebnis3.Left := 3;
    pnErgebnis3.Top := 83;
    pnErgebnis3.Width := 196;
    pnErgebnis3.Height := 32;
    pnErgebnis3.Alignment := taLeftJustify;
    pnErgebnis3.Anchors := [akLeft,akTop,akRight];
    pnErgebnis3.BorderStyle := bsNone;
    pnErgebnis3.Caption := 'Arthur Henkelus';
    pnErgebnis3.ChildOrder := 1;
    pnErgebnis3.Color := 15132390;
    pnErgebnis3.Font.Charset := DEFAULT_CHARSET;
    pnErgebnis3.Font.Color := clWindowText;
    pnErgebnis3.Font.Height := -12;
    pnErgebnis3.Font.Name := 'Tahoma, Arial, sans-serif';
    pnErgebnis3.Font.Style := [];
    pnErgebnis3.Padding.Left := 35;
    pnErgebnis3.ParentFont := False;
    pnErgebnis3.TabOrder := 2;
    sbErgebnis3.SetParentComponent(pnErgebnis3);
    sbErgebnis3.Name := 'sbErgebnis3';
    sbErgebnis3.Left := 1;
    sbErgebnis3.Top := 1;
    sbErgebnis3.Width := 30;
    sbErgebnis3.Height := 30;
    sbErgebnis3.Color := clNone;
    sbErgebnis3.ElementClassName := 'btn';
    sbErgebnis3.ElementFont := efCSS;
    sbErgebnis3.HeightPercent := 100.000000000000000000;
    sbErgebnis3.MaterialGlyph := 'looks_3';
    sbErgebnis3.MaterialGlyphColor := 11752960;
    sbErgebnis3.MaterialGlyphSize := 24;
    sbErgebnis3.TabOrder := 0;
    sbErgebnis3.WidthPercent := 100.000000000000000000;
    pnErgebnis4.SetParentComponent(pnLeft);
    pnErgebnis4.Name := 'pnErgebnis4';
    pnErgebnis4.Left := 3;
    pnErgebnis4.Top := 114;
    pnErgebnis4.Width := 196;
    pnErgebnis4.Height := 32;
    pnErgebnis4.Alignment := taLeftJustify;
    pnErgebnis4.Anchors := [akLeft,akTop,akRight];
    pnErgebnis4.BorderStyle := bsNone;
    pnErgebnis4.Caption := 'Jakob Henkelus';
    pnErgebnis4.ChildOrder := 1;
    pnErgebnis4.Color := 16382457;
    pnErgebnis4.Font.Charset := DEFAULT_CHARSET;
    pnErgebnis4.Font.Color := clWindowText;
    pnErgebnis4.Font.Height := -12;
    pnErgebnis4.Font.Name := 'Tahoma, Arial, sans-serif';
    pnErgebnis4.Font.Style := [];
    pnErgebnis4.Padding.Left := 35;
    pnErgebnis4.ParentFont := False;
    pnErgebnis4.TabOrder := 3;
    sbErgebnis4.SetParentComponent(pnErgebnis4);
    sbErgebnis4.Name := 'sbErgebnis4';
    sbErgebnis4.Left := 1;
    sbErgebnis4.Top := 1;
    sbErgebnis4.Width := 30;
    sbErgebnis4.Height := 30;
    sbErgebnis4.Color := clNone;
    sbErgebnis4.ElementClassName := 'btn';
    sbErgebnis4.ElementFont := efCSS;
    sbErgebnis4.HeightPercent := 100.000000000000000000;
    sbErgebnis4.MaterialGlyph := 'looks_4';
    sbErgebnis4.MaterialGlyphColor := 11752960;
    sbErgebnis4.MaterialGlyphSize := 24;
    sbErgebnis4.TabOrder := 0;
    sbErgebnis4.WidthPercent := 100.000000000000000000;
    pnErgebnis5.SetParentComponent(pnLeft);
    pnErgebnis5.Name := 'pnErgebnis5';
    pnErgebnis5.Left := 3;
    pnErgebnis5.Top := 145;
    pnErgebnis5.Width := 196;
    pnErgebnis5.Height := 32;
    pnErgebnis5.Alignment := taLeftJustify;
    pnErgebnis5.Anchors := [akLeft,akTop,akRight];
    pnErgebnis5.BorderStyle := bsNone;
    pnErgebnis5.Caption := 'Lando Norris';
    pnErgebnis5.ChildOrder := 1;
    pnErgebnis5.Color := 15132390;
    pnErgebnis5.Font.Charset := DEFAULT_CHARSET;
    pnErgebnis5.Font.Color := clWindowText;
    pnErgebnis5.Font.Height := -12;
    pnErgebnis5.Font.Name := 'Tahoma, Arial, sans-serif';
    pnErgebnis5.Font.Style := [];
    pnErgebnis5.Padding.Left := 35;
    pnErgebnis5.ParentFont := False;
    pnErgebnis5.TabOrder := 4;
    sbErgebnis5.SetParentComponent(pnErgebnis5);
    sbErgebnis5.Name := 'sbErgebnis5';
    sbErgebnis5.Left := 1;
    sbErgebnis5.Top := 1;
    sbErgebnis5.Width := 30;
    sbErgebnis5.Height := 30;
    sbErgebnis5.Color := clNone;
    sbErgebnis5.ElementClassName := 'btn';
    sbErgebnis5.ElementFont := efCSS;
    sbErgebnis5.HeightPercent := 100.000000000000000000;
    sbErgebnis5.MaterialGlyph := 'looks_5';
    sbErgebnis5.MaterialGlyphColor := 11752960;
    sbErgebnis5.MaterialGlyphSize := 24;
    sbErgebnis5.TabOrder := 0;
    sbErgebnis5.WidthPercent := 100.000000000000000000;
    pnRight.SetParentComponent(pnTileContent);
    pnRight.Name := 'pnRight';
    pnRight.Left := 200;
    pnRight.Top := 56;
    pnRight.Width := 200;
    pnRight.Height := 177;
    pnRight.Anchors := [akTop];
    pnRight.ChildOrder := 1;
    pnRight.Color := 16316922;
    pnRight.TabOrder := 1;
    lbTippUser.SetParentComponent(pnRight);
    lbTippUser.Name := 'lbTippUser';
    lbTippUser.Left := 0;
    lbTippUser.Top := 0;
    lbTippUser.Width := 200;
    lbTippUser.Height := 15;
    lbTippUser.Align := alTop;
    lbTippUser.Alignment := taCenter;
    lbTippUser.Caption := 'Dein Tipp';
    lbTippUser.Font.Charset := DEFAULT_CHARSET;
    lbTippUser.Font.Color := clWindowText;
    lbTippUser.Font.Height := -12;
    lbTippUser.Font.Name := 'Tahoma, Arial, sans-serif';
    lbTippUser.Font.Style := [fsBold];
    lbTippUser.HeightPercent := 100.000000000000000000;
    lbTippUser.ParentFont := False;
    lbTippUser.WidthPercent := 100.000000000000000000;
    pnTipp1.SetParentComponent(pnRight);
    pnTipp1.Name := 'pnTipp1';
    pnTipp1.Left := 0;
    pnTipp1.Top := 21;
    pnTipp1.Width := 199;
    pnTipp1.Height := 32;
    pnTipp1.Alignment := taLeftJustify;
    pnTipp1.Anchors := [akLeft,akTop,akRight];
    pnTipp1.BorderStyle := bsNone;
    pnTipp1.Caption := 'Max Verstappen';
    pnTipp1.ChildOrder := 1;
    pnTipp1.Color := 15132390;
    pnTipp1.Font.Charset := DEFAULT_CHARSET;
    pnTipp1.Font.Color := clWindowText;
    pnTipp1.Font.Height := -12;
    pnTipp1.Font.Name := 'Tahoma, Arial, sans-serif';
    pnTipp1.Font.Style := [];
    pnTipp1.Padding.Left := 35;
    pnTipp1.ParentFont := False;
    pnTipp1.TabOrder := 0;
    lbPoints1.SetParentComponent(pnTipp1);
    lbPoints1.Name := 'lbPoints1';
    lbPoints1.Left := 162;
    lbPoints1.Top := 7;
    lbPoints1.Width := 18;
    lbPoints1.Height := 19;
    lbPoints1.Alignment := taRightJustify;
    lbPoints1.Anchors := [akTop,akRight];
    lbPoints1.Caption := '+3';
    lbPoints1.Font.Charset := DEFAULT_CHARSET;
    lbPoints1.Font.Color := 57088;
    lbPoints1.Font.Height := -16;
    lbPoints1.Font.Name := 'Tahoma, Arial, sans-serif';
    lbPoints1.Font.Style := [fsBold];
    lbPoints1.HeightPercent := 100.000000000000000000;
    lbPoints1.ParentFont := False;
    lbPoints1.WidthPercent := 100.000000000000000000;
    sbTipp1.SetParentComponent(pnTipp1);
    sbTipp1.Name := 'sbTipp1';
    sbTipp1.Left := 1;
    sbTipp1.Top := 1;
    sbTipp1.Width := 30;
    sbTipp1.Height := 30;
    sbTipp1.Color := clNone;
    sbTipp1.ElementClassName := 'btn';
    sbTipp1.ElementFont := efCSS;
    sbTipp1.HeightPercent := 100.000000000000000000;
    sbTipp1.MaterialGlyph := 'looks_one';
    sbTipp1.MaterialGlyphColor := 11752960;
    sbTipp1.MaterialGlyphSize := 24;
    sbTipp1.TabOrder := 0;
    sbTipp1.WidthPercent := 100.000000000000000000;
    pnTipp2.SetParentComponent(pnRight);
    pnTipp2.Name := 'pnTipp2';
    pnTipp2.Left := 0;
    pnTipp2.Top := 52;
    pnTipp2.Width := 199;
    pnTipp2.Height := 32;
    pnTipp2.Alignment := taLeftJustify;
    pnTipp2.Anchors := [akLeft,akTop,akRight];
    pnTipp2.BorderStyle := bsNone;
    pnTipp2.Caption := 'Mick Schumacher';
    pnTipp2.ChildOrder := 1;
    pnTipp2.Color := 16382457;
    pnTipp2.Font.Charset := DEFAULT_CHARSET;
    pnTipp2.Font.Color := clWindowText;
    pnTipp2.Font.Height := -12;
    pnTipp2.Font.Name := 'Tahoma, Arial, sans-serif';
    pnTipp2.Font.Style := [];
    pnTipp2.Padding.Left := 35;
    pnTipp2.ParentFont := False;
    pnTipp2.TabOrder := 1;
    lbPoints2.SetParentComponent(pnTipp2);
    lbPoints2.Name := 'lbPoints2';
    lbPoints2.Left := 162;
    lbPoints2.Top := 6;
    lbPoints2.Width := 18;
    lbPoints2.Height := 19;
    lbPoints2.Alignment := taRightJustify;
    lbPoints2.Anchors := [akTop,akRight];
    lbPoints2.Caption := '+1';
    lbPoints2.Font.Charset := DEFAULT_CHARSET;
    lbPoints2.Font.Color := clBlack;
    lbPoints2.Font.Height := -16;
    lbPoints2.Font.Name := 'Tahoma, Arial, sans-serif';
    lbPoints2.Font.Style := [fsBold];
    lbPoints2.HeightPercent := 100.000000000000000000;
    lbPoints2.ParentFont := False;
    lbPoints2.WidthPercent := 100.000000000000000000;
    sbTipp2.SetParentComponent(pnTipp2);
    sbTipp2.Name := 'sbTipp2';
    sbTipp2.Left := 1;
    sbTipp2.Top := 1;
    sbTipp2.Width := 30;
    sbTipp2.Height := 30;
    sbTipp2.Color := clNone;
    sbTipp2.ElementClassName := 'btn';
    sbTipp2.ElementFont := efCSS;
    sbTipp2.HeightPercent := 100.000000000000000000;
    sbTipp2.MaterialGlyph := 'looks_two';
    sbTipp2.MaterialGlyphColor := 11752960;
    sbTipp2.MaterialGlyphSize := 24;
    sbTipp2.TabOrder := 0;
    sbTipp2.WidthPercent := 100.000000000000000000;
    pnTipp3.SetParentComponent(pnRight);
    pnTipp3.Name := 'pnTipp3';
    pnTipp3.Left := 0;
    pnTipp3.Top := 83;
    pnTipp3.Width := 199;
    pnTipp3.Height := 32;
    pnTipp3.Alignment := taLeftJustify;
    pnTipp3.Anchors := [akLeft,akTop,akRight];
    pnTipp3.BorderStyle := bsNone;
    pnTipp3.Caption := 'Arthur Henkelus';
    pnTipp3.ChildOrder := 1;
    pnTipp3.Color := 15132390;
    pnTipp3.Font.Charset := DEFAULT_CHARSET;
    pnTipp3.Font.Color := clWindowText;
    pnTipp3.Font.Height := -12;
    pnTipp3.Font.Name := 'Tahoma, Arial, sans-serif';
    pnTipp3.Font.Style := [];
    pnTipp3.Padding.Left := 35;
    pnTipp3.ParentFont := False;
    pnTipp3.TabOrder := 2;
    lbPoints3.SetParentComponent(pnTipp3);
    lbPoints3.Name := 'lbPoints3';
    lbPoints3.Left := 162;
    lbPoints3.Top := 7;
    lbPoints3.Width := 18;
    lbPoints3.Height := 19;
    lbPoints3.Alignment := taRightJustify;
    lbPoints3.Anchors := [akTop,akRight];
    lbPoints3.Caption := '+3';
    lbPoints3.Font.Charset := DEFAULT_CHARSET;
    lbPoints3.Font.Color := 57088;
    lbPoints3.Font.Height := -16;
    lbPoints3.Font.Name := 'Tahoma, Arial, sans-serif';
    lbPoints3.Font.Style := [fsBold];
    lbPoints3.HeightPercent := 100.000000000000000000;
    lbPoints3.ParentFont := False;
    lbPoints3.WidthPercent := 100.000000000000000000;
    sbTipp3.SetParentComponent(pnTipp3);
    sbTipp3.Name := 'sbTipp3';
    sbTipp3.Left := 1;
    sbTipp3.Top := 1;
    sbTipp3.Width := 30;
    sbTipp3.Height := 30;
    sbTipp3.Color := clNone;
    sbTipp3.ElementClassName := 'btn';
    sbTipp3.ElementFont := efCSS;
    sbTipp3.HeightPercent := 100.000000000000000000;
    sbTipp3.MaterialGlyph := 'looks_3';
    sbTipp3.MaterialGlyphColor := 11752960;
    sbTipp3.MaterialGlyphSize := 24;
    sbTipp3.TabOrder := 0;
    sbTipp3.WidthPercent := 100.000000000000000000;
    pnTipp4.SetParentComponent(pnRight);
    pnTipp4.Name := 'pnTipp4';
    pnTipp4.Left := 0;
    pnTipp4.Top := 114;
    pnTipp4.Width := 199;
    pnTipp4.Height := 32;
    pnTipp4.Alignment := taLeftJustify;
    pnTipp4.Anchors := [akLeft,akTop,akRight];
    pnTipp4.BorderStyle := bsNone;
    pnTipp4.Caption := 'Jakob Henkelus';
    pnTipp4.ChildOrder := 1;
    pnTipp4.Color := 16382457;
    pnTipp4.Font.Charset := DEFAULT_CHARSET;
    pnTipp4.Font.Color := clWindowText;
    pnTipp4.Font.Height := -12;
    pnTipp4.Font.Name := 'Tahoma, Arial, sans-serif';
    pnTipp4.Font.Style := [];
    pnTipp4.Padding.Left := 35;
    pnTipp4.ParentFont := False;
    pnTipp4.TabOrder := 3;
    lbPoints4.SetParentComponent(pnTipp4);
    lbPoints4.Name := 'lbPoints4';
    lbPoints4.Left := 175;
    lbPoints4.Top := 7;
    lbPoints4.Width := 5;
    lbPoints4.Height := 19;
    lbPoints4.Alignment := taRightJustify;
    lbPoints4.Anchors := [akTop,akRight];
    lbPoints4.Caption := '-';
    lbPoints4.Font.Charset := DEFAULT_CHARSET;
    lbPoints4.Font.Color := clBlack;
    lbPoints4.Font.Height := -16;
    lbPoints4.Font.Name := 'Tahoma, Arial, sans-serif';
    lbPoints4.Font.Style := [fsBold];
    lbPoints4.HeightPercent := 100.000000000000000000;
    lbPoints4.ParentFont := False;
    lbPoints4.WidthPercent := 100.000000000000000000;
    sbTipp4.SetParentComponent(pnTipp4);
    sbTipp4.Name := 'sbTipp4';
    sbTipp4.Left := 1;
    sbTipp4.Top := 1;
    sbTipp4.Width := 30;
    sbTipp4.Height := 30;
    sbTipp4.Color := clNone;
    sbTipp4.ElementClassName := 'btn';
    sbTipp4.ElementFont := efCSS;
    sbTipp4.HeightPercent := 100.000000000000000000;
    sbTipp4.MaterialGlyph := 'looks_4';
    sbTipp4.MaterialGlyphColor := 11752960;
    sbTipp4.MaterialGlyphSize := 24;
    sbTipp4.TabOrder := 0;
    sbTipp4.WidthPercent := 100.000000000000000000;
    pnTipp5.SetParentComponent(pnRight);
    pnTipp5.Name := 'pnTipp5';
    pnTipp5.Left := 0;
    pnTipp5.Top := 145;
    pnTipp5.Width := 199;
    pnTipp5.Height := 32;
    pnTipp5.Alignment := taLeftJustify;
    pnTipp5.Anchors := [akLeft,akTop,akRight];
    pnTipp5.BorderStyle := bsNone;
    pnTipp5.Caption := 'Lando Norris';
    pnTipp5.ChildOrder := 1;
    pnTipp5.Color := 15132390;
    pnTipp5.Font.Charset := DEFAULT_CHARSET;
    pnTipp5.Font.Color := clWindowText;
    pnTipp5.Font.Height := -12;
    pnTipp5.Font.Name := 'Tahoma, Arial, sans-serif';
    pnTipp5.Font.Style := [];
    pnTipp5.Padding.Left := 35;
    pnTipp5.ParentFont := False;
    pnTipp5.TabOrder := 4;
    lbPoints5.SetParentComponent(pnTipp5);
    lbPoints5.Name := 'lbPoints5';
    lbPoints5.Left := 175;
    lbPoints5.Top := 7;
    lbPoints5.Width := 5;
    lbPoints5.Height := 19;
    lbPoints5.Alignment := taRightJustify;
    lbPoints5.Anchors := [akTop,akRight];
    lbPoints5.Caption := '-';
    lbPoints5.Font.Charset := DEFAULT_CHARSET;
    lbPoints5.Font.Color := clBlack;
    lbPoints5.Font.Height := -16;
    lbPoints5.Font.Name := 'Tahoma, Arial, sans-serif';
    lbPoints5.Font.Style := [fsBold];
    lbPoints5.HeightPercent := 100.000000000000000000;
    lbPoints5.ParentFont := False;
    lbPoints5.WidthPercent := 100.000000000000000000;
    sbTipp5.SetParentComponent(pnTipp5);
    sbTipp5.Name := 'sbTipp5';
    sbTipp5.Left := 1;
    sbTipp5.Top := 1;
    sbTipp5.Width := 30;
    sbTipp5.Height := 30;
    sbTipp5.Color := clNone;
    sbTipp5.ElementClassName := 'btn';
    sbTipp5.ElementFont := efCSS;
    sbTipp5.HeightPercent := 100.000000000000000000;
    sbTipp5.MaterialGlyph := 'looks_5';
    sbTipp5.MaterialGlyphColor := 11752960;
    sbTipp5.MaterialGlyphSize := 24;
    sbTipp5.TabOrder := 0;
    sbTipp5.WidthPercent := 100.000000000000000000;
    btLeft.SetParentComponent(pnTileContent);
    btLeft.Name := 'btLeft';
    btLeft.Left := 256;
    btLeft.Top := 238;
    btLeft.Width := 48;
    btLeft.Height := 48;
    btLeft.Anchors := [akTop,akRight];
    btLeft.Color := 15956480;
    btLeft.ElementClassName := 'btn';
    btLeft.HeightPercent := 100.000000000000000000;
    btLeft.MaterialGlyph := 'arrow_circle_left';
    btLeft.MaterialGlyphColor := clWhite;
    btLeft.MaterialGlyphSize := 48;
    btLeft.TabOrder := 2;
    btLeft.WidthPercent := 100.000000000000000000;
    SetEvent(btLeft, Self, 'OnClick', 'btLeftClick');
    btRight.SetParentComponent(pnTileContent);
    btRight.Name := 'btRight';
    btRight.Left := 318;
    btRight.Top := 238;
    btRight.Width := 48;
    btRight.Height := 48;
    btRight.Anchors := [akTop,akRight];
    btRight.Color := 15956480;
    btRight.ElementClassName := 'btn';
    btRight.HeightPercent := 100.000000000000000000;
    btRight.MaterialGlyph := 'arrow_circle_right';
    btRight.MaterialGlyphColor := clWhite;
    btRight.MaterialGlyphSize := 48;
    btRight.TabOrder := 3;
    btRight.WidthPercent := 100.000000000000000000;
    SetEvent(btRight, Self, 'OnClick', 'btRightClick');
  finally
    pnTileContent.AfterLoadDFMValues;
    lbGpDate.AfterLoadDFMValues;
    lbGpName.AfterLoadDFMValues;
    pnLeft.AfterLoadDFMValues;
    lbErgebnis.AfterLoadDFMValues;
    pnErgebnis1.AfterLoadDFMValues;
    sbErgebnis1.AfterLoadDFMValues;
    pnErgebnis2.AfterLoadDFMValues;
    sbErgebnis2.AfterLoadDFMValues;
    pnErgebnis3.AfterLoadDFMValues;
    sbErgebnis3.AfterLoadDFMValues;
    pnErgebnis4.AfterLoadDFMValues;
    sbErgebnis4.AfterLoadDFMValues;
    pnErgebnis5.AfterLoadDFMValues;
    sbErgebnis5.AfterLoadDFMValues;
    pnRight.AfterLoadDFMValues;
    lbTippUser.AfterLoadDFMValues;
    pnTipp1.AfterLoadDFMValues;
    lbPoints1.AfterLoadDFMValues;
    sbTipp1.AfterLoadDFMValues;
    pnTipp2.AfterLoadDFMValues;
    lbPoints2.AfterLoadDFMValues;
    sbTipp2.AfterLoadDFMValues;
    pnTipp3.AfterLoadDFMValues;
    lbPoints3.AfterLoadDFMValues;
    sbTipp3.AfterLoadDFMValues;
    pnTipp4.AfterLoadDFMValues;
    lbPoints4.AfterLoadDFMValues;
    sbTipp4.AfterLoadDFMValues;
    pnTipp5.AfterLoadDFMValues;
    lbPoints5.AfterLoadDFMValues;
    sbTipp5.AfterLoadDFMValues;
    btLeft.AfterLoadDFMValues;
    btRight.AfterLoadDFMValues;
  end;
end;

end.